@if (installationForm) {
  <ion-grid class="ion-no-padding">
    <form [formGroup]="installationForm">
      @if (!isInEditMode()) {
        <ion-row class="pb-05">
          <ion-col
            size="3"
            size-xs="3"
            size-md="3"
            size-lg="3"
            class="ion-align-self-center"
          >
            <ion-label class="panel-label-text">{{
              'installation_origin' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
            <div class="custom-segment">
              <button
                type="button"
                class="custom-segment-button"
                [class.checked]="installationForm.get('originId')?.value === 1"
                (click)="installationForm.get('originId')?.setValue(1)"
              >
                {{ 'installation_originQC' | translate }}
              </button>
              <button
                type="button"
                class="custom-segment-button"
                [class.checked]="installationForm.get('originId')?.value === 2"
                (click)="installationForm.get('originId')?.setValue(2)"
              >
                {{ 'installation_originQCP' | translate }}
              </button>
            </div>
          </ion-col>
        </ion-row>
      }
      <ion-row class="pb-05">
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text">{{
            'installation_favorite' | translate
          }}</ion-label>
        </ion-col>
        <ion-col
          class="ionic-toggle"
          size="9"
          size-xs="9"
          size-md="9"
          size-lg="9"
        >
          <ion-label class="panel-label-text">{{
            'installation_favorite_no' | translate
          }}</ion-label>
          <ion-toggle color="primary" formControlName="favorite"> </ion-toggle>
          <ion-label class="panel-label-text">{{
            'installation_favorite_yes' | translate
          }}</ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_name' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <input
            class="form-input"
            placeholder="{{ 'installation_name' | translate }}"
            formControlName="name"
            [ngClass]="
              formHelper.isFieldValidCss('name', isFormSubmitAttempted())
            "
          />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_streetNr' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <input
            class="form-input"
            placeholder="{{ 'installation_streetNr' | translate }}"
            formControlName="addressLine1"
            [ngClass]="
              formHelper.isFieldValidCss(
                'addressLine1',
                isFormSubmitAttempted()
              )
            "
          />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_postalcode' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <input
            class="form-input"
            placeholder="{{ 'installation_postalcode' | translate }}"
            formControlName="postalCode"
            [ngClass]="
              formHelper.isFieldValidCss('postalCode', isFormSubmitAttempted())
            "
          />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_city' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          <input
            class="form-input"
            placeholder="{{ 'installation_city' | translate }}"
            formControlName="city"
            [ngClass]="
              formHelper.isFieldValidCss('city', isFormSubmitAttempted())
            "
          />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_country' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          @if (countriesData()) {
            <select
              class="form-select"
              [ngModel]="installationForm.get('country')?.value?.id"
              (ngModelChange)="onCountryChange($event)"
              [ngModelOptions]="{ standalone: true }"
            >
              <option value="">
                {{ 'installation_selectCountry' | translate }}
              </option>
              @for (country of countriesData(); track country.id) {
                <option [value]="country.id">{{ country.name }}</option>
              }
            </select>
          }
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="3"
          size-xs="3"
          size-md="3"
          size-lg="3"
          class="ion-align-self-center"
        >
          <ion-label class="panel-label-text align-label">{{
            'installation_timezone' | translate
          }}</ion-label>
        </ion-col>
        <ion-col size="9" size-xs="9" size-md="9" size-lg="9">
          @if (timezoneData()) {
            <select
              class="form-select"
              [ngModel]="installationForm.get('timezone')?.value?.id"
              (ngModelChange)="onTimezoneChange($event)"
              [ngModelOptions]="{ standalone: true }"
            >
              <option value="">
                {{ 'installation_selectTimezone' | translate }}
              </option>
              @for (timezone of timezoneData(); track timezone.id) {
                <option [value]="timezone.id">{{ timezone.name }}</option>
              }
            </select>
          }
        </ion-col>
      </ion-row>
      @if (canShowButton()) {
        <ion-row>
          <ion-col size="3" size-xs="3" size-md="3" size-lg="3"> </ion-col>
          <ion-col
            size="9"
            size-xs="9"
            size-md="9"
            size-lg="9"
            class="ion-align-self-end"
          >
            <ion-button
              type="button"
              color="primary"
              (click)="onSubmit()"
              [disabled]="
                !installationForm.valid ||
                !canAddInstallation() ||
                isFormDisabled()
              "
            >
              <small>{{ btn_text() | translate }}</small>
            </ion-button>
          </ion-col>
        </ion-row>
      }
      @if (showNextPrevButtons()) {
        <ion-row>
          <ion-col>
            <button
              class="btn-form btn-form-prev"
              type="button"
              (click)="onPrevClicked()"
            >
              {{ 'general_prev' | translate }}
            </button>
            <button
              class="btn-form btn-form-next"
              type="button"
              (click)="onNextWithData()"
              [disabled]="!installationForm.valid || isUpdating()"
            >
              {{ 'general_next' | translate }}
            </button>
          </ion-col>
        </ion-row>
      }
    </form>
  </ion-grid>
}
